/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:ccQuestionari
 * @restrict E
 * @description Componente che gestisce il terzo step "Valutazione" del dettaglio pratica
 * @param {Object[]} steps - Un array che rappresenta i sotto-step da visualizzare
 * @param {Object} currentStep - Rappresenta il sotto-step attualmente visualizzato
 */
(function() {
  'use strict';
  var TlpsQuestionariCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    questionariSrvc,
    propostaTelepassSrvc,
    traslocoTelepassSrvc,
    $state
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.$state = $state;
    this.CONSTANTS = CONSTANTS;

    // Questo componente viene usato sia nella parte di proposta che in quella di trasloco nel post vendita,
    // per poter utilizzare lo stesso componente con metodi e con dati differenti si va a contorllare in quale dei
    // due service sono presenti i dati.
    this.mainSrvc;
    this.propostaTelepassSrvc = propostaTelepassSrvc;
    this.traslocoTelepassSrvc = traslocoTelepassSrvc;
    this.questionariSrvc = questionariSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.ndg;
    this.idProdotto;
    this.idPratica;

    var self = this;

    /**
     * Oggetto contenente la risposta dei servizi
     */
    // this.questionari = null;
    this.risposteQuestionario = {};
    this.risposteObbligatorie = {};
    this.requestQuestionariList = [];
    this.erroriRisposteObbligatorie = [];
    this.numeroDomandeTotali = 0;

    /*
     * -------------------------------------
     * ------ GESTIONE INTERFACCIA ---------
     * -------------------------------------
     */

    /*
     * -------------------------------------
     * GENERAZIONE QUESTIONARI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name creaOggettoRisposteQuestionario
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Crea gli oggetti per salvare le risposte e per indicare la obbligatorietà
     * @param {Object} questionario
     */
    this.creaOggettoRisposteQuestionario = function(questionari) {
      self.risposteQuestionario = {};
      self.risposteObbligatorie = {};
      self.numeroDomandeTotali = 0;
      for (var sezione in questionari) {
        for (var domanda in questionari[sezione].questionarioList) {
          self.numeroDomandeTotali++;

          self.risposteQuestionario[
            questionari[sezione].questionarioList[domanda].codice
          ] = null;

          var risposte =
            questionari[sezione].questionarioList[domanda]
              .rispostaQuestionarioList;

          for (var risposta in risposte) {
            var obbligatorio =
              questionari[sezione].questionarioList[domanda]
                .rispostaQuestionarioList[risposta].obbligatorio;

            if (obbligatorio) {
              var codiceDomanda =
                questionari[sezione].questionarioList[domanda].codice;

              var rispostaObbligatoria =
                questionari[sezione].questionarioList[domanda]
                  .rispostaQuestionarioList[risposta].codice;

              self.risposteObbligatorie[codiceDomanda] = rispostaObbligatoria;
            }
          }
        }
      }
      if (self.mainSrvc.datiPratica.questionarioPraticaList) {
        self.rispostePrecedenti();
      }
    };

    /**
     * @ngdoc method
     * @name rispostePrecedenti
     * @methodOf cbl.telepass.wa.directive:tlpsQuestionari
     * @description Gestisce le risposte precedentemente salvate
     */
    this.rispostePrecedenti = function() {
      for (var i in self.mainSrvc.datiPratica.questionarioPraticaList) {
        for (var j in self.risposteQuestionario) {
          if (
            self.mainSrvc.datiPratica.questionarioPraticaList[i].questionario
              .codice === j
          ) {
            self.risposteQuestionario[j] =
              self.mainSrvc.datiPratica.questionarioPraticaList[
                i
              ].rispostaQuestionario.codice;
          }
        }
      }
    };

    /**
     * @ngdoc method
     * @name controllaRisposteObbligatorie
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Controlla le risposte obbligatorie
     */
    this.controllaRisposteObbligatorie = function() {
      self.erroriRisposteObbligatorie = [];
      //Se non ci sono risposte obbligatorie
      if (!Object.keys(self.risposteObbligatorie).length) {
        return true;
      }

      //Confronto tra le risposte selezionate e quelle obbligatorie
      var risposteObbligatorieIncomplete = false;
      for (var i in self.risposteQuestionario) {
        for (var j in self.risposteObbligatorie) {
          if (
            i === j &&
            self.risposteQuestionario[i] !== self.risposteObbligatorie[j]
          ) {
            risposteObbligatorieIncomplete = true;
            self.erroriRisposteObbligatorie.push(self.risposteObbligatorie[j]);
          }
        }
      }
      if (risposteObbligatorieIncomplete) {
        messaggiFctr.addMessage({
          type: 'E',
          message: 'Ci sono risposte obbligatorie non selezionate'
        });
        return false;
      }

      if (
        Object.keys(self.risposteQuestionario).filter(function(item) {
          return !!self.risposteQuestionario[item];
        }).length < self.numeroDomandeTotali
      ) {
        messaggiFctr.addMessage({
          type: 'E',
          message: 'Ci sono risposte non selezionate'
        });
        return false;
      }

      return true;
    };

    this.setRisposta = function(domanda, risposta) {
      // Se la risposta era già stata data precedentemente la cerco e la aggiorno
      var rispostaPrecedente = self.requestQuestionariList.find(function(item) {
        return item.questionario.codice === domanda.codice;
      });

      if (rispostaPrecedente) {
        rispostaPrecedente.rispostaQuestionario = risposta;
        return;
      }

      var reqObj = {
        id: null,
        questionario: domanda,
        rispostaQuestionario: risposta
      };

      self.requestQuestionariList.push(reqObj);

      self.mainSrvc.datiPratica.questionarioPraticaList =
        self.requestQuestionariList;
    };

    this.datiValidi = function() {
      return self.controllaRisposteObbligatorie();
    };

    /*
     * -------------------------------------
     *           GESTIONE STILI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name getStyleTabMicro
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
     */
    this.getStyleTabMicro = function(currentTabIndex) {
      if (
        self.mainSrvc.isPraticaNavigabile() ||
        self.questionariSrvc.allSurveysCompiled
      ) {
        if (self.currentStep && currentTabIndex === self.currentStep.index) {
          return 'ab-step-tabs cliccabile active-read';
        }

        return 'ab-step-tabs cliccabile ab-last-read';
      }

      // Pratica non navigabile
      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'ab-step-tabs';
      }

      if (self.currentStep && currentTabIndex === self.currentStep.index) {
        return 'ab-step-tabs active';
      }

      return 'ab-step-tabs ab-last';
    };

    /**
     * @ngdoc method
     * @name getStyleStepMicro
     * @methodOf cbl.telepass.wa.directive:ccQuestionari
     * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
     * @param {string} currentStep - Il macro step correntemente visualizzato
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
     */
    this.getStyleStepMicro = function(currentTabIndex) {
      if (self.mainSrvc.isPraticaNavigabile()) {
        return 'step read';
      }

      if (self.currentStep && currentTabIndex < self.currentStep.index) {
        return 'step success';
      }

      return 'step';
    };

    /*
     * -------------------------------------
     *           METODI INIT
     * -------------------------------------
     */

    this.selectCurrentService = function() {
      if (!!self.propostaTelepassSrvc.datiPratica) {
        return self.propostaTelepassSrvc;
      }

      if (!!self.traslocoTelepassSrvc.datiPratica) {
        return self.traslocoTelepassSrvc;
      }

      return null;
    };

    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;
      // messaggiFctr.resetMessages();

      self.mainSrvc = self.selectCurrentService();

      // Assegno la funzione di validazione
      self.mainSrvc.datiValidi = self.datiValidi;

      self.mainSrvc.spinner.showSpinner = true;

      self.requestQuestionariList =
        self.mainSrvc.datiPratica.questionarioPraticaList;

      self.questionariSrvc
        .promiseDettaglioQuestionario('IT', self.mainSrvc.datiPratica.settore)
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.mainSrvc.spinner.showSpinner = false;
              return;
            }
            self.questionari = response.data.result;
            self.creaOggettoRisposteQuestionario(self.questionari);
          },
          function(reason) {
            if (self.messaggiFctr.processaResponse(reason)) {
              self.mainSrvc.spinner.showSpinner = false;

              return;
            }
          }
        )
        .finally(function() {
          self.mainSrvc.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     *           INIZIALIZZAZIONE
     * -------------------------------------
     */

    self.init();
  };

  TlpsQuestionariCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsQuestionariSrvc',
    'TlpsPropostaSrvc',
    'TlpsTraslocoTelepassSrvc',
    '$state'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsQuestionari/tlpsQuestionari.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsQuestionariComponent = {
    bindings: {},
    controller: TlpsQuestionariCtrl,
    controllerAs: 'questionariCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsQuestionari', TlpsQuestionariComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsQuestionari/tlpsQuestionari.cmpt.js
// module id = 35
// module chunks = 0